// grain.js — animated film-grain canvas pinned to the viewport.
// Pure 2D, intentionally lightweight; renders 3 noise frames and cycles them.

(function () {
  const canvas = document.getElementById('grain');
  if (!canvas) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ctx = canvas.getContext('2d', { alpha: true });
  const DPR = Math.min(window.devicePixelRatio || 1, 1.5);

  // Pre-render N noise patches and cycle
  const FRAMES = 4;
  const TILE = 256;
  let tiles = [];

  function buildTiles() {
    tiles = [];
    for (let f = 0; f < FRAMES; f++) {
      const off = document.createElement('canvas');
      off.width = TILE; off.height = TILE;
      const octx = off.getContext('2d');
      const id = octx.createImageData(TILE, TILE);
      const d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        const n = (Math.random() * 255) | 0;
        d[i] = d[i + 1] = d[i + 2] = n;
        d[i + 3] = 28; // alpha — keep noise subtle
      }
      octx.putImageData(id, 0, 0);
      tiles.push(off);
    }
  }

  function resize() {
    canvas.width = Math.floor(window.innerWidth * DPR);
    canvas.height = Math.floor(window.innerHeight * DPR);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
  }

  function draw(t) {
    const i = Math.floor(t / 80) % FRAMES;
    const tile = tiles[i];
    if (!tile) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // tile across viewport
    for (let x = 0; x < canvas.width; x += TILE) {
      for (let y = 0; y < canvas.height; y += TILE) {
        ctx.drawImage(tile, x, y);
      }
    }
  }

  let raf = 0;
  function loop(t) {
    draw(t);
    raf = requestAnimationFrame(loop);
  }

  buildTiles();
  resize();

  if (reducedMotion) {
    // single static draw at lower alpha; no animation
    draw(0);
  } else {
    raf = requestAnimationFrame(loop);
  }

  window.addEventListener('resize', () => {
    resize();
    if (reducedMotion) draw(0);
  }, { passive: true });

  // pause when tab is hidden
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && raf) { cancelAnimationFrame(raf); raf = 0; }
    else if (!document.hidden && !raf && !reducedMotion) {
      raf = requestAnimationFrame(loop);
    }
  });
})();
